module.exports = __webpack_public_path__ + "static/simic-hybrid-2-0b6be3aec24d5be6695a04ad15e1cc4d.png";